import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectExportFreightShipmentsJobByJobGuid = (state: unknown, { jobGuid }: { jobGuid: string }) => {
  const jobIdToJobMap = get(state, 'jobIdToJobMap', emptyObject);
  return jobIdToJobMap[jobGuid];
};
